import { CreateFilterSet } from "@app/resource-filters/filter-sets/createFilterSet";
import { FilterSet } from "@app/resource-filters/filter-sets/filterSet";
import { ResourceType } from "@app/resources";
import ServiceBase from "@app/shared/serviceBase";

/** Handles communication across the wire when retrieving and interacting with filter-sets. */
class FilterSetService extends ServiceBase {
  /**
   * Creates a filter-set based on the given createFilterSet. Returns the created filter-set.
   * @param createFilterSet
   */
  public async create(createFilterSet: CreateFilterSet): Promise<FilterSet> {
    return await this.makePost<FilterSet>(`filtersets`, { ...createFilterSet });
  }

  /**
   * Deletes a filter-set given the filterSetId
   * @param filterSetId
   */
  public async delete(filterSetId: number): Promise<void> {
    return await this.makeDelete(`filtersets/${filterSetId}`);
  }

  /**
   * Gets the filter-set given the filterSetId and resourceType
   * @param filterSetId
   * @param resourceType
   */
  public async get(filterSetId: number, resourceType: ResourceType): Promise<FilterSet> {
    return await this.makeGet<FilterSet>(`filtersets/${filterSetId}?resourceType=${resourceType}`);
  }

  /**
   * Gets all filter-set given the resourceType
   * @param resourceType
   */
  public async getFilterSets(resourceType: ResourceType): Promise<FilterSet[]> {
    return await this.makeGet<FilterSet[]>(`filtersets/?resourceType=${resourceType}`);
  }

}

export { FilterSetService };
